import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import ReactPlayer from 'react-player/lazy';

import { trackVideoPlaying } from '../../tracking';

interface IYoutubePlayerProps {
  src: string;
}

export const YoutubePlayer: React.FC<IYoutubePlayerProps> = ({ src }) => {
  /* istanbul ignore next */
  const handlePlay = useEventCallback(() => {
    trackVideoPlaying('youtube');
  });

  return (
    <ReactPlayer url={src} width="100%" height="100%" controls playing data-name="ReactPlayer" onPlay={handlePlay} />
  );
};
